import React, { useContext } from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import { getMenuAdminMappings } from '@totem/components/ui_components/menus/mainMenu/admin_mappings';
import TabContentMenu from '@totem/components/ui_components/menus/tabContentMenu';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const MappingsManagementPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <IBCard>
        <TabContentMenu items={getMenuAdminMappings(userProfile)} />
      </IBCard>
    </ContentLayout>
  );
};

export default MappingsManagementPage;
